<template>
  <Table ref="table"
    :options="fields" 
    :tableValue="tableValue" 
    :otherOpt="otherOpt"
    :customSlotOpt="slotOpt"
    :customPaginationOpt="searchParams"
    @change="handlerTableChange"
    @actionClick="handlerActionClick"></Table>
</template>

<script>
import { fields, slotOpt } from '../configs/tableFields'
import Table from '@/views/backstageSupport/components/table'
import { setStorage } from '@/utils'
import { mapMutations } from 'vuex'
const FilterGroup = require('../../utils/getFilterGroup')

const filterGroup = new FilterGroup.FilterGroup()

export default {
  props: {
    searchParams: Object
  },
  data() {
    return {
      fields,
      slotOpt,
      tableValue: [],
      otherOpt: {
        pagination: false
      },
      requestParams:{}
    }
  },
  components: {
    Table
  },
  watch: {
    searchParams: {
      handler() { // 外部参数一旦发生变化触发表格重新请求数据
        this.getTableValue()
      },
      deep: true
    }
  },
  // mounted() {
  //   this.getTableValue()
  // },
  methods: {
    ...mapMutations('filterGroup', [
      'clearCompanyExp'
    ]),
    handlerTableChange() {
      // console.log(params)
    },
    tableLoading(v) {
      this.$refs.table.settingLoading(v)
    },
    async getTableValue() {
      try {
        this.tableLoading(true)
        const {page, pageSize, requestCols, ...otherParams} = this.searchParams
        const cols = this.getRequestCols(requestCols)
        const offset = page > 1 ? (page - 1) * pageSize : 0
        const params = {
          ...otherParams,
          pageSize,
          offset,
          requestCols: cols,
        }
        this.requestParams = params
        const resultData = await filterGroup.getResultList(params) // 获取列表页的数据
        this.handlerDataSetting(resultData) // 处理数据的去处
      } catch (error) {
        console.log(error)
      } finally {
        this.tableLoading(false)
      }
    },
    handlerDataSetting(v) {
      const { result, total } = v
      this.tableValue = result
      this.$emit('updateTotal', total)
    },
    getRequestCols(initCols) {
      const disabled = ['index', 'application_date']
      const init = [
        { alias: 'abstract_ab' },
        { alias: 'inventors' },
        { alias: 'last_legal_status_stat' },
        { alias: 'family_id' }
      ]
      const collect = this.fields.reduce((pre, cur) => {
        const { dataIndex } = cur
        const item = { alias: dataIndex }
        if (!disabled.includes(dataIndex)) {
          pre.push(item)
        }
        return pre
      }, [])
      return init.concat(collect, initCols)
    },
    handlerActionClick(params) {
      this.$router.push('/competitorData/detail?index=' + params.row.index)
      let requsetParams ={
        requestParams:JSON.stringify(this.requestParams)
      }
      setStorage('requsetParams', requsetParams, 0)
      this.clearCompanyExp()  // 跳转详情后清空企业名录的检索式，回跳之后避免侧边结果请求速度比左侧名录更快导致报错的情况
    }
  },
  beforeDestroy() {
      this.clearCompanyExp()  // 清空企业名录的检索式，回跳之后避免侧边结果请求速度比左侧名录更快导致报错的情况
  }
}
</script>
